import { Prop } from '@typegoose/typegoose'
import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('RelatedEntityInput')
export class RelatedEntity {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('rel') })
  _id: string
}
